import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DragDropFileList, FileListFileProps, Label } from '@mercai/clever'
import { api, ORDERS_CENTER_INVOICE_URL } from '@/services'
import { getFileNameAndExtension } from '@/helpers'

import { SaleOrderProps } from '@/types'
import { FinanceDocumentsProps } from './documents.type'
import styles from './documents.module.css'

export const FinaceDocumentsTab = ({
  values = {} as SaleOrderProps,
  onSuccessUploadFiles,
}: FinanceDocumentsProps) => {
  const { t } = useTranslation('componentOrderCenterForm')

  const [dataFilesDeductionXml, setDataFilesDeductionXml] = useState<
    FileListFileProps[]
  >([])

  const [dataFilesDeductionPdf, setDataFilesDeductionPdf] = useState<
    FileListFileProps[]
  >([])

  useEffect(() => {
    const invoice = values.invoices?.[0]

    if (invoice?.deductionPdfFile) {
      const pdfFile = getFileNameAndExtension(invoice?.deductionPdfFile)
      setDataFilesDeductionPdf([
        {
          id: pdfFile.fileName,
          name: `${pdfFile.fileName}.${pdfFile.extension}`,
          url: invoice.deductionPdfFile,
          uploaded: true,
        },
      ])
    }

    if (invoice?.deductionXmlFile) {
      const xmlFile = getFileNameAndExtension(invoice?.deductionXmlFile)
      setDataFilesDeductionXml([
        {
          id: xmlFile.fileName,
          name: `${xmlFile.fileName}.${xmlFile.extension}`,
          url: invoice.deductionXmlFile,
          uploaded: true,
        },
      ])
    }
  }, [])

  return (
    <div className={styles.box}>
      <div className={styles.field}>
        <Label>{t('paymentDeductionLabelXml')}</Label>
        <DragDropFileList
          translations={{
            clickToUpload: t('uploadClickToUpload'),
            dragFile: t('uploadDragFile'),
            sizeFile: t('uploadSizeFile'),
          }}
          urlAdd={ORDERS_CENTER_INVOICE_URL(values.invoices?.[0]?.uuid || '')}
          configsRequest={{
            fileField: 'deduction_xml_file',
            method: 'PATCH',
          }}
          axiosInstance={api}
          data={dataFilesDeductionXml}
          onChangeData={setDataFilesDeductionXml}
          successedUpload={onSuccessUploadFiles}
        />
      </div>

      <div className={styles.field}>
        <Label>{t('paymentDeductionLabelPdf')}</Label>
        <DragDropFileList
          translations={{
            clickToUpload: t('uploadClickToUpload'),
            dragFile: t('uploadDragFile'),
            sizeFile: t('uploadSizeFile'),
          }}
          urlAdd={ORDERS_CENTER_INVOICE_URL(values.invoices?.[0]?.uuid || '')}
          configsRequest={{
            fileField: 'deduction_pdf_file',
            method: 'PATCH',
          }}
          axiosInstance={api}
          data={dataFilesDeductionPdf}
          onChangeData={setDataFilesDeductionPdf}
          successedUpload={onSuccessUploadFiles}
        />
      </div>
    </div>
  )
}
